/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestCreateBaseRequest,
  RequestDeleteBaseRequestWrapper,
  RequestUpdateBaseRequest,
  ResponseGetAllBasesResponse,
} from '../models/index';
import {
    RequestCreateBaseRequestFromJSON,
    RequestCreateBaseRequestToJSON,
    RequestDeleteBaseRequestWrapperFromJSON,
    RequestDeleteBaseRequestWrapperToJSON,
    RequestUpdateBaseRequestFromJSON,
    RequestUpdateBaseRequestToJSON,
    ResponseGetAllBasesResponseFromJSON,
    ResponseGetAllBasesResponseToJSON,
} from '../models/index';

export interface BasesCreateBasePostRequest {
    req: RequestCreateBaseRequest;
}

export interface BasesDeleteBasePostRequest {
    wrapperReq: RequestDeleteBaseRequestWrapper;
}

export interface BasesUpdateBasePostRequest {
    req: RequestUpdateBaseRequest;
}

/**
 * 
 */
export class BasesApi extends runtime.BaseAPI {

    /**
     * 新しい拠点を登録する
     * 新しい拠点を登録
     */
    async basesCreateBasePostRaw(requestParameters: BasesCreateBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling basesCreateBasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bases/CreateBase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateBaseRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 新しい拠点を登録する
     * 新しい拠点を登録
     */
    async basesCreateBasePost(requestParameters: BasesCreateBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.basesCreateBasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 拠点情報を論理削除
     * 拠点情報を論理削除
     */
    async basesDeleteBasePostRaw(requestParameters: BasesDeleteBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['wrapperReq'] == null) {
            throw new runtime.RequiredError(
                'wrapperReq',
                'Required parameter "wrapperReq" was null or undefined when calling basesDeleteBasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bases/DeleteBase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestDeleteBaseRequestWrapperToJSON(requestParameters['wrapperReq']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 拠点情報を論理削除
     * 拠点情報を論理削除
     */
    async basesDeleteBasePost(requestParameters: BasesDeleteBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.basesDeleteBasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 全拠点を取得
     * 全拠点を取得
     */
    async basesGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetAllBasesResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bases/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetAllBasesResponseFromJSON));
    }

    /**
     * 全拠点を取得
     * 全拠点を取得
     */
    async basesGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetAllBasesResponse>> {
        const response = await this.basesGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 拠点情報 を更新
     * 拠点情報 を更新
     */
    async basesUpdateBasePostRaw(requestParameters: BasesUpdateBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling basesUpdateBasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bases/UpdateBase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateBaseRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 拠点情報 を更新
     * 拠点情報 を更新
     */
    async basesUpdateBasePost(requestParameters: BasesUpdateBasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.basesUpdateBasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
